(function treatmentBundleLogicFactory(root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.GratiaeTreatmentBundle = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function createTreatmentBundleLogic() {
  'use strict';

  function sellingPlanForLine(line, bundlePlanId, mode) {
    if (mode !== 'ritual') return '';
    if (line && Object.prototype.hasOwnProperty.call(line, 'sellingPlanId')) {
      return String(line.sellingPlanId || '').trim();
    }
    return String(bundlePlanId || '').trim();
  }

  function buildBundleItems(lines, opts) {
    const options = opts || {};
    const mode = options.mode;
    const bundlePlanId = options.bundlePlanId;
    const subscribeCode = options.subscribeCode;
    const onetimeCode = options.onetimeCode;

    return (lines || []).map(function (line) {
      const item = {
        id: Number(line.variantId),
        quantity: 1,
        properties: {}
      };
      const plan = sellingPlanForLine(line, bundlePlanId, mode);
      if (plan) item.selling_plan = Number(plan);
      item.properties._gratiae_mode = mode === 'ritual' ? 'subscription' : 'onetime';
      if (mode === 'ritual') {
        if (line.wasCents) item.properties._gratiae_list_cents = String(line.wasCents);
        if (line.subscribeCents) item.properties._gratiae_subscribe_cents = String(line.subscribeCents);
        if (subscribeCode && !plan) item.properties._gratiae_discount_code = subscribeCode;
      } else if (onetimeCode) {
        item.properties._gratiae_discount_code = onetimeCode;
      }
      return item;
    });
  }

  return {
    sellingPlanForLine: sellingPlanForLine,
    buildBundleItems: buildBundleItems
  };
});
